export default "__VITE_ASSET__Lcm14i22__"